import { render, staticRenderFns } from "./DashboardRecentOrders.vue?vue&type=template&id=303b7161"
import script from "./DashboardRecentOrders.vue?vue&type=script&lang=js"
export * from "./DashboardRecentOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports